/**
 * Makes immutable file-version history discoverable without cluttering item names.
 *
 * Version numbers represent durable audit history, so one shared badge opens the
 * same history workflow from every Vault layout.
 */
import { Badge } from '@/components/ui'

interface VaultVersionBadgeProps {
  name: string
  versionNumber?: number
  onOpen: () => void
}

export function VaultVersionBadge({ name, versionNumber, onOpen }: VaultVersionBadgeProps) {
  return (
    <Badge asChild variant="outline">
      <button
        type="button"
        aria-label={`Open version history for ${name}, latest version ${versionNumber ?? 'loading'}`}
        className="cursor-pointer bg-background hover:bg-muted"
        onClick={(event) => {
          event.stopPropagation()
          onOpen()
        }}
      >
        v{versionNumber ?? '…'}
      </button>
    </Badge>
  )
}
